module.exports = __webpack_public_path__ + "assets/img/arrow-left.d7715ee0.svg";